export const RENTAL_LEDGER_REQUIRED_HEADER = '(Required)'

export const RENTAL_LEDGER_OPTIONAL_HEADER = '(Highly Recommended)'

export const RENTAL_LEDGER_REQUIRED_DESCRIPTION =
  'To demonstrate suitability you must add a rental ledger for most recent address.'

export const RENTAL_LEDGER_OPTIONAL_DESCRIPTION =
  'To demonstrate suitability consider adding a rental ledger.'

export const RENTAL_LEDGER_STATUS_MISSING = 'Rental ledger: Missing'

export const RENTAL_LEDGER_RECOVERY_CTA = 'Fix now'
